import { Currency } from "@uniswap/sdk-core";

export type TokenType = {
  address: string;
  name: string;
  symbol: string;
  synonym?: string;
  iconSrc: string;
  decimals: number;
};

export interface Token {
  coin_type: string;
  decimals: number;
  name: string;
  symbol: string;
}

export const TOKEN_LIST: TokenType[] = [
    {
      name: "Aptos",
      symbol: "APT",
      iconSrc: "/external_media/aptos-bg-black.png",
      address: "0x1::aptos_coin::AptosCoin",
      decimals: 8,
    },
  {
    name: "MAU",
    symbol: "MAU",
    iconSrc: "/external_media/MAU-icon.jpeg",
    address: "0x83b619e2d9e6e10d15ed4b714111a4cd9526c1c2ae0eec4b252a619d3e8bdda3::MAU::MAU",
    decimals: 8,
  },
    {
      name: "USDC Coin",
      symbol: "USDC (LayerZero)",
      iconSrc: "https://stage-api.aptools.io/images/usdc-(layerzero).png",
      address: "0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::USDC",
      decimals: 6,
    },
    {
      name: "Tether USD",
      symbol: "USDT (LayerZero)",
      iconSrc: "https://stage-api.aptools.io/images/usdt-(layerzero).png",
      address: "0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::USDT",
      decimals: 6,
    },
    {
      name: "Wrapped Ether",
      symbol: "WETH (LayerZero)",
      iconSrc: "https://stage-api.aptools.io/images/weth-(layerzero).png",
      address: "0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::WETH",
      decimals: 6,
    },
];

export const getMergedTokenList = (): TokenType[] => {
  // Retrieve the token list from localStorage, if it exists
  const storedTokenListString = localStorage.getItem("TOKEN_LIST");
  const localStorageTokenList: TokenType[] = storedTokenListString
    ? JSON.parse(storedTokenListString)
    : [];

  // Create a new Set to store unique addresses for deduplication
  const uniqueAddresses = new Set(localStorageTokenList.map((token) => token.address));

  // Add tokens from STATIC_TOKEN_LIST that aren't already in localStorageTokenList
  const mergedTokenList = [
    ...TOKEN_LIST.filter((staticToken) => !uniqueAddresses.has(staticToken.address)),
    ...localStorageTokenList,
  ];

  /* return TOKEN_LIST; */
  return mergedTokenList;
};

export const addTokenToStorage = (token: Token) => {
  // Retrieve the existing list from localStorage and parse it, or default to an empty array
  let tokenList: TokenType[] = [];
  try {
    const rawList = localStorage.getItem("TOKEN_LIST");
    tokenList = rawList ? JSON.parse(rawList) : [];
  } catch (e) {
    console.log(e);
  }

  // Prepare the token object for storage
  const tokenToStore: TokenType = {
    address: token.coin_type,
    name: token.name,
    symbol: token.symbol,
    iconSrc: `https://stage-api.aptools.io/images/${token.symbol?.toLowerCase()}.png`,
    decimals: token.decimals,
  };

  // Check if the token is already in the list to avoid duplicates
  const existingTokenIndex = tokenList.findIndex(
    (t: TokenType) => t.address === tokenToStore.address
  );
  if (existingTokenIndex >= 0) {
    // Update existing token data
    //tokenList[existingTokenIndex] = tokenToStore;
  } else {
    // Add new token
    tokenList.push(tokenToStore);
  }

  // Save the updated list back to localStorage
  try {
    localStorage.setItem("TOKEN_LIST", JSON.stringify(tokenList));
  } catch (e) {
    console.log(e);
  }
};

export const addPreparedTokenToStorage = (token: Currency) => {
  // Retrieve the existing list from localStorage and parse it, or default to an empty array
  let tokenList: TokenType[] = [];
  try {
    const rawList = localStorage.getItem("TOKEN_LIST");
    tokenList = rawList ? JSON.parse(rawList) : [];
  } catch (e) {
    console.log(e);
  }

  // Prepare the token object for storage
    const tokenToStore: TokenType = {
      address: (token as any).address || "",
      name: token.name || "",
      symbol: token.symbol || "",
      iconSrc: "",
      decimals: token.decimals,
    };

  // Check if the token is already in the list to avoid duplicates
  const existingTokenIndex = tokenList.findIndex(
    (t: TokenType) => t.address === tokenToStore.address
  );
  if (existingTokenIndex >= 0) {
    // Update existing token data
    //tokenList[existingTokenIndex] = tokenToStore;
  } else {
    // Add new token
    tokenList.push(tokenToStore);
  }

  // Save the updated list back to localStorage
  try {
    localStorage.setItem("TOKEN_LIST", JSON.stringify(tokenList));
  } catch (e) {
    console.log(e);
  }
};
